export let props = ['title', 'time', 'type','format','close', 'preIcon', 'small', 'clearable']
export let model = {
  pretime: undefined,
}
export let computed = {
    currenttime: {
        get () {
            // console.log(this.time)
            return this.time
        },
        set (val) {
            // console.log(val)
            if (this.type == 'date') {
                const d = new Date(val);
                const returnDate = new Date(
                  `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} 00:00:00`
                );
                this.$emit('update:time', returnDate);
            }
            if(this.type == 'year'){
                if (val && new Date(val).getYear() <= new Date().getYear()) {
                    this.$emit('update:time', new Date(val).format('yyyy'))
                }else {
                    this.$message({
                        message: '请选择正确日期！',
                        type: 'warning'
                    })
                }
            }
            if(this.type == 'month'){
                if (val && new Date(val).getYear()>new Date().getYear() ) {
                    this.$message({
                        message: '请选择正确日期！',
                        type: 'warning'
                    })
                }else if(val && new Date(val).getYear() == new Date().getYear()&&new Date(val).getMonth()+1 > new Date().getMonth()+1) {
                    this.$message({
                        message: '请选择正确日期！',
                        type: 'warning'
                    })
                }else {
                    this.$emit('update:time', val)
                }
            }
            if(this.type == 'week'){
                if (val && new Date(val).getYear()>new Date().getYear() ) {
                    this.$message({
                        message: '请选择正确日期！',
                        type: 'warning'
                    })
                }else if(val && new Date(val).getYear() == new Date().getYear()&&new Date(val).getMonth()+1 > new Date().getMonth()+1) {
                    this.$message({
                        message: '请选择正确日期！',
                        type: 'warning'
                    })
                }else if(val && new Date(val).getYear() == new Date().getYear()&&new Date(val).getMonth()+1 == new Date().getMonth()+1&& new Date(val).getDate() > new Date().getDate()) {
                    this.$message({
                        message: '请选择正确日期！',
                        type: 'warning'
                    })
                }else {
                    this.$emit('update:time', val)
                }
            }
        }
    },
}
